<template>
  <div id="content" class="sections">
    <Head>
      <!-- Primary Meta Tags -->
      <title>{{ changeMetatagHtml($t("bestSellers.metaTitle")) }}</title>

      <link rel="canonical" href="https://komatools.com/es/los-mas-vendidos"/>
      <link rel="alternate" href="https://komatools.com/es/los-mas-vendidos" hreflang="es"/>
      <link rel="alternate" href="https://komatools.com/en/best-sellers" hreflang="en"/>
      <link rel="alternate" href="https://komatools.com/fr/meilleures-ventes" hreflang="fr"/>
      <link rel="alternate" href="https://komatools.com/es/los-mas-vendidos" hreflang="x-default"/>

      <meta name="title" :content="changeMetatagHtml($t('bestSellers.metaTitle'))">

      <meta name="description" :content="$t('bestSellers.metaDescription')">

      <!-- Open Graph / Facebook -->
      <meta property="og:type" content="website">
      <meta property="og:url" content="https://komatools.com/">
      <meta property="og:title" :content="changeMetatagHtml($t('bestSellers.metaTitle'))">
      <meta property="og:description" :content="$t('bestSellers.metaDescription')">
      <meta property="og:image" content="https://komatools.com/img/komatoolsSocial.jpg">

      <!-- Twitter -->
      <meta property="twitter:card" content="summary_large_image">
      <meta property="twitter:url" content="https://komatools.com/">
      <meta property="twitter:title" :content="changeMetatagHtml($t('bestSellers.metaTitle'))">
      <meta property="twitter:description" :content="$t('bestSellers.metaDescription')">
      <meta property="twitter:image" content="https://komatools.com/img/komatoolsSocial.jpg">
    </Head>
    <div class="section light paddingBigger">
      <div>
        <div class="banner centered">
          <div class="header">
            <h1 class="title">{{ $t("bestSellers.title") }}</h1>
            <h2 v-html="$t('bestSellers.subTitle')" class="subTitle"></h2>
          </div>
        </div>
        <details>
          <summary v-html="$t('bestSellers.summary.title')"></summary>
          <p v-html="$t('bestSellers.summary.descriptionParagraph1')"></p>
          <p v-html="$t('bestSellers.summary.descriptionParagraph2')"></p>
          <p v-html="$t('bestSellers.summary.descriptionParagraph3')"></p>
          <p v-html="$t('bestSellers.summary.descriptionParagraph4')"></p>
          <p v-html="$t('bestSellers.summary.descriptionParagraph5')"></p>
        </details>
        <div class="options buttons wrap centered">
          <a class="button accent" v-for="(filter, index) in filtersRef" :key="index">
						<span
                @click="filterData(filter.code)"
                :class="{ active: filter.code === activeFilter }"
            >{{ $t(filter.text) }}</span>
          </a>
        </div>
        <div class="banner centered" v-if="error">
          <p v-html="$t(error)"></p>
        </div>
        <div v-else>
          <ArticlesList :articles="searchedArticles"/>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import getArticles from '../../composables/getArticles'
import GENERIC_VARIABLES from "../../../config";
import ArticlesList from '@/components/ArticlesList.vue'
import {Head} from '@vueuse/head'
import {computed} from 'vue'


// Composition API and external JS
export default {
  name: "BestSellers",
  components: {ArticlesList, Head},
  setup() {
    const top = "true"
    const novelties = "false"
    const filters = []
    const subcategories = []
    const {articles, error, load} = getArticles(GENERIC_VARIABLES.PRODUCT_BRAND, subcategories, filters, novelties, top)

    load()

    /**
     * This is a function to remove the special character | from javascript
     * More information: https://stackoverflow.com/questions/5796718/html-entity-decode
     */
    const changeMetatagHtml = (html) => {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;

    }
    const searchedArticles = computed(() => {
      return articles.value;
    })

    return {searchedArticles, error, GENERIC_VARIABLES, changeMetatagHtml}
  }
}
</script>
